import { P2GBox } from '@parcel2go/core-ui';

export const CircularPercentageProgress = ({
  value,
  children,
  size = 100,
  strokeWidth = 10
}: {
  value: number;
  children: React.ReactNode;
  size: number;
  strokeWidth: number;
}) => {
  return (
    <P2GBox position="relative" display="inline-block" width={size} height={size}>
      <P2GBox
        display="flex"
        alignItems="center"
        justifyContent="center"
        height={`${size}px`}
        width={`${size}px`}
        position="absolute"
        top={0}
        left={0}
      >
        {children}
      </P2GBox>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - strokeWidth / 2}
          stroke="#e6e6e6"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - strokeWidth / 2}
          stroke="#27ce5a"
          strokeWidth={strokeWidth}
          style={{ transition: 'stroke-dasharray 0.3s ease' }}
          fill="none"
          strokeDasharray={`${value * ((Math.PI * (size - strokeWidth)) / 100)} ${Math.PI * (size - strokeWidth) - value * ((Math.PI * (size - strokeWidth)) / 100)}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
    </P2GBox>
  );
};
